// import { Box, Grid, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';

import MomBaby from 'assets/images/ssg_bg_circle.webp';
import React from 'react';
import { SimButton } from 'components/SimButton';
import SimCircleBanner from 'components/SimCircleBanner';
import { SimTypography } from 'components/SimTypography';
import Slider from 'react-slick';
import { useTheme } from '@mui/material/styles';


const Banner = () => {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true
	});

	const words = ['Autism', "Asperger's?", 'ADHD?', 'Stunted Growth?', 'Speech delay?'];

	const sliderOpts = {
		dots: false,
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		fade: true
	};

	const LeftSide = () => (
		<Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
			<Box marginBottom={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
				<SimTypography
					marginTop={{ xs: 4, sm: 4, md: 4, lg: 4 }}
					variant='h3'
					color={theme.palette.text.headerLight}
					sx={{ fontWeight: 500 }}>
					Concerned about your
					<div>child's development with</div>
				</SimTypography>
				<Box
					width={{ xs: '80vw', sm: '60vw', md: 450 }}
					height={{ xs: '10vw', sm: '10vw', md: '5vw' }}
					bgcolor={'transparent'}
					margin={0}
					padding={0}>
					<Slider {...sliderOpts}>
						{words.map((item, i) => (
							<Box key={i} margin={0} padding={0}>
								<Box
									display={'block'}
									width={1}
									margin={0}
									padding={0}
									height={1}
									sx={{
										textDecoration: 'none',
										transition: 'all .2s ease-in-out'
									}}>
									<SimTypography
										color={theme.palette.secondary.mainOrange}
										variant={'h3'}
										sx={{
											fontWeight: 400
										}}>
										{item}
									</SimTypography>
								</Box>
							</Box>
						))}
					</Slider>
				</Box>
			</Box>
			<Box>
				<SimTypography component='p' color={theme.palette.text.bodyLight}>
					Let us help you. As parents, we want a happy & healthy child. SimSouls is a team of parents,
					therapists, neuro scientists, and doctors bonded by one purpose:
				</SimTypography>
				<SimTypography
					variant='h6'
					component='p'
					marginTop={1}
					color={theme.palette.text.bodyLight}
					sx={{
						fontWeight: 500,
						textAlign: 'center',
						fontStyle: 'italic'
					}}>
					“Every child deserves a full life.”
				</SimTypography>
			</Box>
			<Box marginY={{ md: 2 }} paddingBottom={4} display={'flex'} justifyContent='flex-end'>
				<SimButton
					variant='contained'
					backgroundColor={theme.palette.background.btnSecondaryCTA}
					color={theme.palette.text.btnSecondaryCTA}
					size='large'
					href={'/services'}>
					Start screening
				</SimButton>
			</Box>
		</Box>
	);

	return (
		<Grid container spacing={4} paddingBottom={-4} marginBottom={0}>
			<Grid item container alignItems={'center'} xs={12} md={6}>
				<Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
					<LeftSide />
				</Box>
			</Grid>

			<Grid
				item
				container
				alignItems={'flex-end'}
				justifyContent={'flex-end'}
				xs={12}
				md={6}
				data-aos='flip-left'
				data-aos-easing='ease-out-cubic'
				data-aos-duration='2000'
				zIndex={2}>
				<SimCircleBanner zIndex={2} paddingTop={{ xs: 0, sm: 0, md: 0, lg: 2 }} src={MomBaby} />
			</Grid>
		</Grid>
	);
};

export { Banner };
